module.exports = __webpack_public_path__ + "static/media/login.e4e5ffb5.png";